// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"NewItemDropdown__buttonGroup--2pUoM","chevronDown":"NewItemDropdown__chevronDown--3PPEZ","plus":"NewItemDropdown__plus--499Wm","root":"NewItemDropdown__root--39p8a"};